// Constantes partagées relatives à la vidéo Grünt #45.
// Chemin du fichier, durée totale et offset de départ dans la chanson.
// Centralisées ici pour que la section MPC et la section Crash Outro
// utilisent exactement les mêmes valeurs.

/** Chemin relatif (public/) de la vidéo Grünt — sans préfixe base. */
export const GRUNT_VIDEO_URL = 'video/grunt-45.mp4';

/** Durée réelle du clip grunt-45.mp4 en secondes. */
export const CLIP_DURATION_SECONDS = 240;

/** Offset du clip en secondes. */
export const CLIP_START_IN_SONG_SECONDS = 0.1;
